/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef ,useEffect} from 'react'
import { useGLTF, useAnimations } from '@react-three/drei'

export default function Model({ ...props }) {
  const group = useRef()
  const { nodes, materials, animations } = useGLTF('/RubberTube/tubeRope2.glb')
  const { actions } = useAnimations(animations, group)
  useEffect(() => {
    actions.Animation6.play();
    actions.Animation6.repetitions = 1;
    actions.Animation6.clampWhenFinished = true;
  }, [actions]);
  return (
    <group ref={group} {...props} dispose={null}>
      <group>
        <mesh name="rope2" geometry={nodes.rope2.geometry} material={materials.材質} />
      </group>
    </group>
  )
}

useGLTF.preload('/RubberTube/tubeRope2.glb')
